<template>
    <section class="footer-area gray-bg pb-90 mt-50">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-5">
                    <div class="footer-item-1 mt-30">
                        <router-link to="/"><img src="/img/transmall-logo.png" alt="Logo" style="width: 150px;"></router-link>
                        <span>Copyright @2020</span>
                        <ul>
                            <li><a href="#">Quality policy</a></li>
                            <li><a href="#">Customer Policy </a></li>
                            <li><router-link to="/about-us">About Us</router-link></li>
                        </ul>
                        <div class="footer-info">
                            <ul>
                                <li><i class="ion ion-md-pin"></i> 123 Street, ABC Building, <br> Eldoret,
                                    Kenya
                                </li>
                                <li><i class="ion ion-ios-mail"></i>example@gmail.com</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 offset-lg-2 col-md-2 col-sm-4">
                    <div class="footer-social mt-30">
                        <h5 class="title">Social Links</h5>
                        <ul>
                            <li><a href="https://www.facebook.com/info.tanver">Facebook</a></li>
                            <li><a href="#">Twitter</a></li>
                            <li><a href="#">Instagram</a></li>
                            <li><a href="skype:live:taherul.islam_1">Skype</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4 col-md-5 col-sm-8">
                    <div class="footer-item-2 mt-30">
                        <h5 class="title">Newsletters</h5>
                        <form action="#">
                            <div class="input-box mt-25">
                                <input type="email" placeholder="Your email">
                            </div>
                            <div class="input-box mt-25">
                                <button class="main-btn">Submit <i class="ion ion-ios-send"></i></button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>